import { render, staticRenderFns } from "./ResourceEditWrapper.vue?vue&type=template&id=7d568274&scoped=true&"
import script from "./ResourceEditWrapper.vue?vue&type=script&lang=js&"
export * from "./ResourceEditWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ResourceEditWrapper.vue?vue&type=style&index=0&id=7d568274&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d568274",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
